
import React, { useEffect, useState } from 'react'
import './dataTableApplications.scss'
import { DataGrid } from '@mui/x-data-grid';
import { userApplicationsColumns } from '../../data/dataSource';
import { Link } from 'react-router-dom';
import { collection, deleteDoc, doc, onSnapshot, query, orderBy, where, getDocs} from "firebase/firestore";
import { db } from '../../firebase'



const DataTableUserApplication = ({applicantId}) => {

  const [ userApplication, setUserApplication ] = useState([])

  // const applicantId = route.params

  const [ isLoading, setIsLoading ] = useState(true)


  const Spinner = () => {
    return(
      <div className='spinner-container'>
          <div className='loading-spinner'></div>
      </div>
    )
  }


  


  useEffect(() => {

    
    //LISTEN REAL TIME

    const applicationQuery = async() => {

      const applicationRef = (collection(db, "visa"));

      const q = query(applicationRef, where("userId", "==", applicantId));

      const querySnapshot = await getDocs(q);

      let list = []

      querySnapshot.forEach((doc) => {

        list.push({id: doc.id, ...doc.data(), date: doc.data().timeStamp.toDate().toLocaleString()})

        console.log(list)

        setUserApplication(list)
        setIsLoading(false)
        
        // console.log(userApplication)
      });

      // setIsLoading(false)

      // setapplicationData(doc.data())
      
      // console.log(userApplication)

    }
    
    applicationQuery()   
  },[])

  console.log('user Application: ',userApplication)


  const handleDelete = async (id) => {

    try{

      await deleteDoc(doc(db, "visa", id));
      setUserApplication(userApplication.filter((item) => item.id !== id))

    }catch(err){

      console.log(err)

    }
   
  }

  const actionColumn = [

    { field: 'action', headerName: 'Action', width: 160, 
    
            renderCell:(params) => {
                return(
                    <div className='cellAction'>
                       <Link to={`/applications/${params.row.id}`} style={{textDecoration:"none"}}>
                          <div className="viewbutton">View</div>
                       </Link>
                       <div className='deletebutton' onClick={() => handleDelete(params.row.id)}>Delete</div>
                   
                    </div>
                )
            }
    }
      
  ]  

  return (
    <div className="datatable">
     
      {isLoading ? <Spinner/> : 
        <DataGrid
            className="userApplicationTableGrid"
            rows={userApplication}
            columns={userApplicationsColumns.concat(actionColumn)}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            getRowId={(row) => row.visaId}
            
        />
    }

      
    </div>
  )
}

export default DataTableUserApplication















// import MaterialTable from 'material-table'
// import { ThemeProvider } from '@mui/styles'
// import { createTheme } from '@mui/material';

// import DeleteOutline from '@material-ui/icons/DeleteOutline';
// import Edit from '@material-ui/icons/Edit';
// import FilterList from '@material-ui/icons/FilterList';
// import FirstPage from '@material-ui/icons/FirstPage';
// import LastPage from '@material-ui/icons/LastPage';
// import Remove from '@material-ui/icons/Remove';
// import SaveAlt from '@material-ui/icons/SaveAlt';
// import Search from '@material-ui/icons/Search';
// import ViewColumn from '@material-ui/icons/ViewColumnOutlined';

// import AddBox from '@material-ui/icons/AddBox';
// import Check from '@material-ui/icons/Check';
// import Clear from '@material-ui/icons/Clear';
// import ChevronRight from '@material-ui/icons/ChevronRight';
// import ChevronLeft from '@material-ui/icons/ChevronLeft';
// import ArrowDownward from '@material-ui/icons/ArrowDownward';


// import * as XLSX from 'xlsx'
// import React, { forwardRef, useEffect, useState, useContext } from 'react'
// import './dataTableApplications.scss'
// import { DataGrid } from '@mui/x-data-grid';
// import { userApplicationsColumns } from '../../data/dataSource';
// // import { applicationsColumns } from '../../data/dataSource';
// import { Link } from 'react-router-dom';
// import { collection, deleteDoc, doc, onSnapshot, query, orderBy, where, getDocs, getDoc} from "firebase/firestore";
// // import { collection, getDocs,  deleteDoc, doc, onSnapshot, query, orderBy, where, getDoc } from "firebase/firestore";
// import { db } from '../../firebase'
// import ConfirmBox from '../ConfirmBox';

// import { AuthContext } from '../../context/AuthContext'


// const DataTableUserApplication = ({applicantId}) => {


//   const [ data, setData ] = useState([])
 
//   const [ isLoading, setIsLoading ] = useState(true)

//   const [open, setOpen] = useState(false);

//   const [deleteId, setDelete] = useState("");

//   const { currentUser } = useContext(AuthContext)
  
//   const userId = currentUser.uid;

//   const [adminRole, setAdminRole] = useState("")

//    const [ userApplication, setUserApplication ] = useState([])



//     const getAdminRole = async() => {
      
//             const docRef = doc(db, "admins", userId);
      
//             const docSnap = await getDoc(docRef);
      
            
//             if (docSnap.exists()) {
      
//               setAdminRole(docSnap.data().role)

//             } else {

//               console.log("No such document!");
//             }
//     }

//     useEffect(()=>  {

//       getAdminRole()

//     }, [])



//   const Spinner = () => {
//     return(
//       <div className='spinner-container'>
//           <div className='loading-spinner'></div>
//       </div>
//     )
//   }



//   useEffect(() => {

//     //LISTEN REAL TIME

//     const applicationQuery = async() => {

//       const applicationRef = (collection(db, "visa"));

//       const q = query(applicationRef, where("userId", "==", applicantId));

//       const querySnapshot = await getDocs(q);

//       let list = []

//       querySnapshot.forEach((doc) => {

//         list.push({...doc.data()})

//         console.log(list)

//         setUserApplication(list)
//         setIsLoading(false)
        
//         // console.log(userApplication)
//       });

//       // setIsLoading(false)

//       // setapplicationData(doc.data())
      
//       // console.log(userApplication)

//     }
    
//     applicationQuery()   
//   },[])

 
 
// //   useEffect(() => {
   
// //     const collectionRef = collection(db, "visa")
// //     const queryApplication = query(collectionRef, orderBy("timeStamp", "desc"))
// //     // const queryDate = query(queryApplication, where("status", '!=', "ORDER_COMPLETED"))
// //     const unsub = onSnapshot(queryApplication, (snapShot) => {
// //       let list = [];
// //       snapShot.docs.forEach((doc) => {
// //         list.push({ id: doc.id, ...doc.data(), timeStamp: doc.data().timeStamp.toDate()})
        
// //       })
// //       setData(list)
// //       setIsLoading(false)

// //       // console.log("user created at:", data.createdAt.toDate());
// //     }, 
// //       (error) => {
// //         console.log(error)
// //       }
// //     );

// //     return () => {
// //       unsub();
// //     }

// // // //END LISTEN REAL TIME    

// //   },[])


//   function openDelete(id) {
//     setOpen(true);
//     setDelete(id);
//   }
  
//     console.log(data)
  
//     const handleDelete = async() => {
  
//       await deleteDoc(doc(db, "visa", deleteId));
        
//         setData(data.filter((item) => item.id !== deleteId))
  
//         setOpen(false)
  
//     }


//     const tableIcons = {
//     Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
//     Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
//     Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
//     Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
//     DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
//     Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
//     Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
//     Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
//     FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
//     LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
//     NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
//     PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
//     ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
//     Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
//     SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
//     ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
//     ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
//   };

//     const theme = createTheme({
//       status: {
//         danger: 'red',
//       },
//     });

//     const downloadExcel=()=>{
//       const newData=data.map(row=>{
//         delete row.tableData
//         return row
//       })
//       const workSheet=XLSX.utils.json_to_sheet(newData)
//       const workBook=XLSX.utils.book_new()
//       XLSX.utils.book_append_sheet(workBook,workSheet,"Applicantions")
//       //Buffer
//       let buf=XLSX.write(workBook,{bookType:"xlsx",type:"buffer"})
//       //Binary string
//       XLSX.write(workBook,{bookType:"xlsx",type:"binary"})
//       //Download
//       XLSX.writeFile(workBook,"ApplicantionsData.xlsx")


//     }

//   return (
//     <>
//     <div style={{}}>

//       {
//         isLoading

//         ?

//         <Spinner/>

//         :

//         <>
//         {/* <div className='datatableTitle'>
//           User Visa Application
//         </div> */}
          
    
//         <ThemeProvider theme={theme}>

//           <MaterialTable
//           icons={tableIcons}
//           title="All Visa Applications"
//           columns={userApplicationsColumns}
//           data={userApplication}


        

//         actions={[

//           {
//             action: rowData => ({
//               icon: tableIcons.ViewColumn,
//               tooltip: "View Application",
//               onClick: (event, rowData) => window.location.href=`/applicantions/${rowData.id}` 
//             }),
//             position: "row"
//           },

//           {
//             action: rowData => ({
//               icon: tableIcons.Delete,
//               tooltip: "Delete Applications",
//               onClick: (event, rowData) => openDelete(rowData.id)
//             }),
//             position: "row"
//           },
//             // {icon:()=><button>Export</button>,// you can pass icon too
//             // tooltip:"Export to Excel",
//             // onClick:()=>downloadExcel(),
//             // isFreeAction:true
//             // },
//         ]}


//           // options={{
//           //   exportButton: true,
//           //   sorting: true,
//           //   selection: true,
//           //   pageSize : 20,
//           //   actionsColumnIndex: -1,
//           //   exportCsv: (columns, data) => {
//           //     downloadExcel()
//           //   },

//           //   headerStyle: {
//           //     fontWeight: 'bold',
//           //     fontSize: 16
//           //   }
//           // }}

//           />

//         </ThemeProvider>
//         </>

//       }
 
//     </div>

//      <ConfirmBox
//       open={open}
//       closeDialog={() => setOpen(false)}
//       // title={deleteData?.name}
//       deleteFunction={handleDelete}
//     />
//     </>
//   );
// }

// export default DataTableUserApplication ;








